import React, { useEffect, useState } from "react";
import classNames from "classnames";
import moment from "moment";
import { Icon } from "../../../components/Component";

const Header = ({headerInfo, color, ...props }) => {
  return (
    <>
      <div className="fm-head bg-lighter">
          <div className="fm-count"><Icon name="contact fs-22px"></Icon></div>
          <div className="fm-title">
            <span className="sub-title text-muted">Order Name:</span>  
            <h5 className="title fw-normal">{headerInfo.order_name}</h5>
            <p className="sub-title mb-0"><small className="me-2">Issue Date:</small>{moment(headerInfo.issue_date).format("Do MMM, YYYY h:mm a")}</p>
            <p className="sub-title mb-0"><small className="me-2">Due Date:</small>{moment(headerInfo.due_date).format("Do MMM, YYYY h:mm a")}</p>
          </div>   
      </div>
      {
        headerInfo.product_name &&
        <div className="fm-head bg-lighter">
          <div className="fm-count"><Icon name="package fs-22px"></Icon></div>
          <div className="fm-title">
            <span className="sub-title text-muted">Finished Product:</span>  
            <h5 className="title fw-normal">{headerInfo.product_name}</h5>
            <p className="sub-title mb-0">Quantity: {headerInfo.product_quantity}</p>
          </div>        
        </div>
      }
    </>
  );
};


export default Header;